import { ca } from '@cian/analytics';
import { IRosreestrDataMeta } from '../../../services/rosreestrData';
import { ECadastralFieldsNames } from '../../../types/reducers/rosreestrData';

export const trackCheckResultReceived = (meta: IRosreestrDataMeta[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'filling',
    action: 'kadastral_number',
    label: 'check_result',
    products: [
      {
        extra: {
          check_result: meta.reduce((result, field) => {
            const key = field.key === ECadastralFieldsNames.BuildingCadastralNumber ? 'house_data' : 'land_data';

            return { ...result, [key]: Number(!!field.checkedValue) };
          }, {}),
        },
      },
    ],
  });
};
